import { Create } from '@fund/api-modules';
import CreateByUser from './decorator/CreateByUser';
import NoticeModel from '../model/announcement.model';
import PublicNoticeListModel from '../model/public-notice-list.model';
import TransformResponse from './decorator/TransformResponse';

@CreateByUser({
  getUserParams: (userInfo) => {
    const {
      utoken,
      ctoken,
      uid,
      deviceid,
    } = userInfo;
    return {
      utoken,
      ctoken,
      deviceid,
      version: '6.5.5',
      customerNo: uid,
      mobileKey: deviceid,
      product: 'EFund',
      plat: 'web',
    };
  },
})

@Create({
  baseURL: 'https://np-anotice-fund.eastmoney.com', // 更多地址参考 https://acttest.1234567.com.cn/topic/2019/fund-config/api
  // baseURL: 'https://np-anotice-fund-test.eastmoney.com',
  params: {
    deviceid: '1234567.py.service',
    version: '6.5.5',
    appVersion: '6.5.5',
    product: 'EFund',
    plat: 'web',
  },
})

class EMAnoticeApi {
// 获取公告信息
  @TransformResponse((res) => NoticeModel.objectArrayWithKeyValuesArray(res.data.list || []))
  getAnoticelist(FCODE) {
    return this.GET('api/security/ann', {
      client: 'fund_app',
      ann_type: 'Fund',
      page_index: 1,
      page_size: 2,
      stock_list: FCODE,
      new_column_code: '0',
    });
  }

  // 获取公告信息
  @TransformResponse((res) => PublicNoticeListModel.objectWithKeyValues(res.data || {}))
  getNoticeList(FCODE) {
    return this.GET('api/security/ann', {
      client: 'fund_app',
      ann_type: 'Fund',
      page_index: 1,
      page_size: 2,
      stock_list: FCODE,
      new_column_code: '0',
    });
  }
}
export default new EMAnoticeApi();
